import { Link } from 'react-router-dom';
import {
  ChevronRight,
  Landmark,
  PieChart,
  Settings,
  Shapes,
  Tag,
  Target,
  type LucideIcon,
} from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';

interface Shortcut {
  to: string;
  label: string;
  description: string;
  icon: LucideIcon;
}

const SHORTCUTS: Shortcut[] = [
  { to: '/contas', label: 'Contas', description: 'Saldos e carteiras', icon: Landmark },
  { to: '/categorias', label: 'Categorias', description: 'Despesas e receitas', icon: Shapes },
  { to: '/tags', label: 'Tags', description: 'Etiquetas de lançamentos', icon: Tag },
  { to: '/relatorios', label: 'Relatórios', description: 'Análises e gráficos', icon: PieChart },
  { to: '/orcamentos', label: 'Orçamentos', description: 'Planejamento mensal', icon: Target },
  { to: '/movimentacoes/reviews', label: 'Open Finance', description: 'Revisar movimentações sincronizadas', icon: Landmark },
  { to: '/config', label: 'Configurações', description: 'Conta e preferências', icon: Settings },
];

/** Hub "Mais": atalhos para as telas fora da bottom nav do mobile. */
export function MorePage() {
  return (
    <section className="space-y-6">
      <PageHeader title="Mais" subtitle="Acesse todas as áreas do Lira." />

      <ul className="divide-y divide-border overflow-hidden rounded-[var(--radius-panel)] bg-surface shadow-card">
        {SHORTCUTS.map(({ to, label, description, icon: Icon }) => (
          <li key={to}>
            <Link
              to={to}
              className="flex items-center gap-3 px-4 py-4 transition-colors hover:bg-canvas"
            >
              <span className="grid size-10 shrink-0 place-items-center rounded-full bg-primary-weak text-primary">
                <Icon className="size-5" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium text-ink">{label}</p>
                <p className="truncate text-sm text-muted">{description}</p>
              </div>
              <ChevronRight className="size-5 shrink-0 text-muted" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
